export default __webpack_public_path__ + "static/media/2023-03-02T06_03_26.253Z_2_8.2682da2d.jpeg";